import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  LABEL: `${cleanedFilename(__filename)}-label`,
  INPUT: `${cleanedFilename(__filename)}-input`,
};
